import { render } from 'preact'
import { BaseComponent } from 'utils/base-component'
import { Modal } from './modal'
import { Incentive as IncentiveApp } from '../incentive/Incentive'
import { Screens } from './services/screens'

export class SignUp extends BaseComponent {
  static cssClass = 'js-signup'

  init() {
    // Mount the incentive paywall in all .js-incentive elements
    const incentiveEls = document.querySelectorAll('.js-incentive')
    incentiveEls.forEach((el) => {
      el.replaceChildren('')
      this.renderIncentive(el)
    })

    // Attach modal openers to .js-signup-paid-modal and .js-signup-modal
    const modalTriggers = document.querySelectorAll('.js-signup-paid-modal, .js-signup-modal')
    modalTriggers.forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault()
        this.mountModal()
      })
    })

    // Optionally, handle login modal triggers
    const signInEls = document.querySelectorAll('.js-login-modal')
    signInEls.forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault()
        this.mountModal(Screens.SignInScreen)
      })
    })
  }

  private renderIncentive(el: Element): void {
    render(
      <IncentiveApp
        onReload={() => window.location.reload()}
        // Pass a callback so the paywall can open the modal
        onOpenModal={(page = Screens.SignUpScreen) => this.mountModal(page)}
      />,
      el
    )
  }

  private mountModal(page = Screens.SignUpScreen): void {
    render(
      <Modal
        action={page}
        source="incentive"
        onClose={() => this.closeModal()}
        onReload={() => window.location.reload()}
      />,
      this.root
    )
    document.body.style.setProperty('overflow', 'hidden')
    document.body.appendChild(this.root)
  }

  private closeModal(): void {
    render(null, this.root)
    document.body.style.removeProperty('overflow')
    document.body.removeChild(this.root)
  }
}
